import { createFileRoute, redirect } from '@tanstack/react-router';
import { hasAnyPermission } from '@/lib/auth';
import { guardRoute } from '@/lib/route-guards';

/** `/payroll` opens the first payroll page the user may use: runs, else standing amounts. */
export const Route = createFileRoute('/_app/payroll')({
  beforeLoad: ({ context }) => {
    guardRoute(context.auth, '/payroll');
    const user = context.auth.user;
    if (hasAnyPermission(user, ['payroll.read', 'payroll.disburse'])) {
      throw redirect({ to: '/payroll/runs' });
    }
    if (hasAnyPermission(user, ['payroll.prepare', 'payroll.tax.manage'])) {
      throw redirect({ to: '/payroll/standing' });
    }
    throw redirect({ to: '/' });
  },
});
